import React, { useState, useEffect } from 'react';
import { Card, Accordion } from 'antd-mobile';

import { UrlSearch } from "../../../utils/utils";

import * as Api from "../../../api/email";
import { TimeFormatType, EmailCategory, AuditingStatus, EmailType, EmailStatus, EmailStatusStyle } from '../utils/const';
import { Loading, Descriptions } from '../components';
import CompanyInfo from '../components/CompanyInfo';
import Audit from './Audit';

import moment from 'moment';
import '../index.css';

function TemplateDetail(props) {

  const [templateId, setTemplateId] = useState("");
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    initData()
  }, [])

  const initData = () => {
    const id = UrlSearch("id");
    setTemplateId(id);
    if (id) {
      getInfo(id);
    }
  }

  const getInfo = (templateId) => {
    const data = {
      TemplateCategory: EmailCategory,
      TemplateId: templateId,
    }
    setLoading(true);
    Api.DescribeEmailTemplateWithRisk(data).then(res => {
      if (res && res.length) {
        setInfo(res[0] || {});
      }
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }

  const infoOptions = (info) => [
    { label: '模版ID', value: info.TemplateId },
    { label: '模板名称', value: info.TemplateName || info.Name },
    { label: '模板摘要', value: info.Abstract },
    { label: '模板主题', value: info.Subject },
    { label: '模板类型', value: EmailType[info.TriggerType] },
    { label: '申请时间', value: moment(info.CreateTime * 1000).format(TimeFormatType.time_xg) },
    { label: '当前状态', value: <span className={EmailStatusStyle[info.Status]}>{EmailStatus[info.Status]}</span> },
    { label: '编辑器', value: info.Editor },
    // { label: '模版内容', value: info.Template },
  ]
  return (
    <div className="container">
      <h3 className='mb-10'>邮件模版：{templateId}</h3>
      <Loading loading={loading} error={errorMessage} >
        <div>
          <Card>
            <Card.Body>
              <CompanyInfo CompanyId={info.CompanyId} />
            </Card.Body>
          </Card>
          <Card style={{ marginTop: '10px' }}>
            <Card.Header title="模版信息" />
            <Card.Body>
              <Descriptions options={infoOptions(info)} />
              <Accordion className='list-accordion'>
                <Accordion.Panel header={<span style={{ fontWeight: 500, fontSize: 15,  marginLeft: '-11px' }}>模板信息：</span>}>
                  <iframe title="模板页面" srcDoc={info.HtmlContent} frameBorder={0} width="100%" style={{ minHeight: 600 }}></iframe>
                </Accordion.Panel>
              </Accordion>
            </Card.Body>
          </Card>
          {AuditingStatus.includes(info.Status) ?
            <div style={{ marginTop: '20px' }}>
              <h3 style={{ marginBottom: '10px' }}>模版审核：</h3>
              <Audit info={info} fetchBack={() => getInfo(templateId)} />
            </div> : null}
        </div>
      </Loading>
    </div>
  )
}

export default TemplateDetail